import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/** Footer type icon size (neutral or coloured). */
export const workspaceCardFooterTypeIconSizeClassName = "size-3.5 shrink-0";

/** Neutral footer type icon — n-40 on the warm neutral ladder. */
export const workspaceCardFooterTypeIconClassName = cn(
  workspaceCardFooterTypeIconSizeClassName,
  "text-neutral-400",
);

export interface WorkspaceCardFooterTypeIconProps {
  icon: LucideIcon;
  className?: string;
  strokeWidth?: number;
}

export function WorkspaceCardFooterTypeIcon({
  icon: Icon,
  className,
  strokeWidth = 1.75,
}: WorkspaceCardFooterTypeIconProps) {
  return (
    <Icon
      className={cn(workspaceCardFooterTypeIconClassName, className)}
      strokeWidth={strokeWidth}
    />
  );
}

/** Title row with optional leading type icon. */
export function WorkspaceCardFooterTitleRow({
  icon,
  children,
}: {
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-w-0 items-center gap-1.5">
      {icon}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
